import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Skills from "./components/Skills";
import Work from "./components/Work";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Blogs from "./components/Blogs"
import {Routes, Route} from "react-router-dom";

function App() {
  return (
    <div className="select-none font-sans antialiased">
        <Navbar />
        <Routes>
          <Route path="/" element={<><Home /><About /><Skills /><Work /><Contact /></>} />
          <Route exact path="/blogs" element={<Blogs />}/>
        </ Routes>
        <Footer />
      {/* <Navbar />
      <Home />
      <About />
      <Skills />
      <Work />
      <Contact />
      <Footer /> */}
    </div>
  );
}

export default App;
